"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const React = require("react");
const CheckboxGroupContext = React.createContext(null);
function useCheckboxGroupProvider() {
  return React.useContext(CheckboxGroupContext);
}
exports.CheckboxGroupContext = CheckboxGroupContext;
exports.useCheckboxGroupProvider = useCheckboxGroupProvider;
